import React, { useEffect, useRef, useState } from "react";
import "./About.css";
import ganesh from "./Assets/ganesh.jpg"
import adi from "./Assets/adi.jpg"

export default function About() {
  const [openId, setOpenId] = useState(null);
  const toggle = (id) => setOpenId((prev) => (prev === id ? null : id));
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          obs.disconnect();
        }
      },
      { threshold: 0.2 }
    );

    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <section
      ref={ref}
      className={`jb-about ${visible ? "is-visible" : ""}`}
    >
      <div className="jb-about-inner">

        {/* PAGE HEADER */}
        <header className="jb-pagehead">
          <h1 className="jb-page-title">ABOUT</h1>
          <p className="jb-page-sub">
            We are brothers exploring how an affordable robot can assist in cooking and cuisine exploration.
          </p>
        </header>

        {/* SECTION: GOAL STATEMENT */}
        <div className="jb-section">
          <div className="jb-section-head">
            <div className="jb-section-title">GOAL STATEMENT</div>
            <div className="jb-section-line" />
          </div>

          <p className="jb-body">
            Getting fully nutritious and tasty food to every family — and giving people a choice to explore
            human foods easily and freely. They deserve it. We deserve it.
          </p>
        </div>

        {/* SECTION: TEAM */}
        <div className="jb-section">
          <div className="jb-section-head">
            <div className="jb-section-title">TEAM</div>
            <div className="jb-section-line" />
          </div>

          <p className="jb-body">
            We’re building Junebase with a hands-on approach: prototype, test, iterate — then scale what works.
          </p>

          <div className="jb-cards">

            {/* Card 1 - GANESH */}
            <button
              type="button"
              className={`jb-card ${openId === "sai" ? "flipped" : ""}`}
              onClick={() => toggle("sai")}
            >
              <div className="jb-card-inner">

                {/* FRONT */}
                <div className="jb-card-face jb-card-front">
                  {/* Full-bleed image */}
                  <img className="jb-card-photo" src={ganesh} alt="Ganesh" />

                  {/* Bottom fade + text */}
                  <div className="jb-card-overlay">
                    <div className="jb-card-name">Sai Chamarty</div>
                    <div className="jb-card-role">ROBOTICS • PROTOTYPING • FULL STACK</div>
                  </div>

                  {/* Bottom-left: LinkedIn */}
                  <a
                    href="https://www.linkedin.com/in/sai-chamarty-263342274/"
                    className="jb-card-linkedin"
                    onClick={(e) => e.stopPropagation()}
                    aria-label="LinkedIn"
                  >
                    in
                  </a>

                  {/* Bottom-right: flip */}
                  <div className="jb-card-action" aria-hidden="true">+</div>
                </div>

                {/* BACK */}
                <div className="jb-card-face jb-card-back">
                  <p className="jb-card-paragraph">
                    Sai is an undergraduate at UC Davis pursuing Computer Science, with a strong passion
                    for robotics. He has demonstrated leadership by founding the Swift Coding Club at UC Davis
                    and growing it into a 40-member organization with over six active teams. At Junebase,
                    he designed and built the version-one robot through rapid prototyping and hands-on iteration,
                    bridging software, hardware, and system design.
                  </p>

                  <a
                    href="https://www.linkedin.com/in/sai-chamarty-263342274/"
                    className="jb-card-linkedin"
                    onClick={(e) => e.stopPropagation()}
                  >
                    in
                  </a>

                  <div className="jb-card-action">×</div>
                </div>
              </div>
            </button>


            {/* Card 2 */}
            <button
              type="button"
              className={`jb-card ${openId === "adi" ? "flipped" : ""}`}
              onClick={() => toggle("adi")}
            >
              <div className="jb-card-inner">

                {/* FRONT */}
                <div className="jb-card-face jb-card-front">
                  {/* Full-bleed image */}
                  <img className="jb-card-photo" src={adi} alt="Ganesh" />

                  {/* Bottom fade + text */}
                  <div className="jb-card-overlay">
                    <div className="jb-card-name">SHASHANK CHAMARTY</div>
                    <div className="jb-card-role">SIMULATION • MACHINE LEARNING • PHYSICS</div>
                  </div>

                  {/* Bottom-left: LinkedIn */}
                  <a
                    href="https://www.linkedin.com/in/shashank-chamarty-124a1b316/"
                    className="jb-card-linkedin"
                    onClick={(e) => e.stopPropagation()}
                    aria-label="LinkedIn"
                  >
                    in
                  </a>

                  {/* Bottom-right: flip */}
                  <div className="jb-card-action" aria-hidden="true">+</div>
                </div>

                {/* BACK */}
                <div className="jb-card-face jb-card-back">
                  <p className="jb-card-paragraph">
                    Shashank is a high school student deeply interested in robotics simulation and
                    GPU-accelerated workflows. He works extensively with NVIDIA tools, including Omniverse,
                    and focuses on simulation-driven development. At Junebase, he is designing and building
                    the arm kinematics and motion control systems that enable precise, coordinated robot movement.
                  </p>
                  <a
                    href="https://www.linkedin.com/in/shashank-chamarty-124a1b316/"
                    className="jb-card-linkedin"
                    onClick={(e) => e.stopPropagation()}
                  >
                    in
                  </a>

                  <div className="jb-card-action">×</div>
                </div>

              </div>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}